const url = process.env.REACT_APP_URL;
const url_transporte = url + "/api/transporte/";
const url_usuario = url + "/api/usuario/";
const url_venta = url + "/api/venta/";
const url_file = url + "/api/file/";
//encomienda
const url_encomienda = url + "/api/encomienda/";
////
/**
 * VERBO_ACCION (en ingles)
 * ejemplos:
 * DELETE_XXXX:"",
 * UPDATE_XXXX:"",
 * CREATE_XXXX:"",
 * READ_XXXX:"",
 */
export const API = {
  AUTH: {
    REFRESH: url_usuario + "auth/refresh",
    CLOSE_SESSIONS: url_usuario + "auth/close",
    GET_SESSIONS: url_usuario + "auth/sessions/",
    LOGIN: url_usuario + "auth",
    LOGOUT: url_usuario + "auth/logout",
  },
  FILE: {
    GET_PROFILE: url_file + "show",
  },
  TIPO_SALON: {
    GET_ALL: url_transporte + "tiposalon",
  },
  SERVICIO:{
    CREATE: url_venta + "servicio",
    DELETE: url_venta + "servicio/:id/:motivo",
    GET_ONE: url_venta + "servicio/:id",
    UPDATE_ONE: url_venta + "servicio/:id"
  },
  USUARIO: {
    GET_INFO: url_usuario + "usuario/info",
    UPDATE: url_usuario + "usuario",
    SEARCH_USER: url_usuario + "usuario/search",
  },
  PERSONAL: {
    GET_ALL_PERSONAL: url_usuario + "personal",
    GET_PERSONAL_BY_IDS: url_usuario + "personal/info",
    GET_PERSONAL: url_usuario + "personal/:id",
    SAVE_PERFIL:url_usuario+ "personal",
    GET_LIST_PERSONAL_ABORDO: url_venta + 'personalabordo/listpercompany',
    TIPO_PERSONAL: url_venta + 'tipopersonal',
    CREATE_PERSONAL_ABORDO: url_venta +"personalabordo",
    DELETE_PERSONAL_ABORDO:url_venta +"personalabordo/:id"
    /*GET_TYPE_PERSONAL: url_usuario + "tipopersonal",
    DELETE_PERSONAL: url_usuario + "personal/:id",
    UPDATE_PERSONAL: url_usuario + "personal/editar/:id",
    UPDATE_CREDENTIAL: url_usuario + "personal/credencial/:id",
    GET_ALL_INFO: url_usuario + "personal/info/all",*/
  },
  SUCURSAL: {
    GET_BRANCH: url_venta + "sucursal/listar",
    GET: url_venta + "sucursal/",
    GET_MANY: url_venta + "sucursal/many",
    GET_ONE: url_venta + "sucursal/:id",
    DELETE_ONE: url_venta + "sucursal/:id",
  },
  EMPRESA: {
    //UPDATE_INFO: url_usuario + "empresa/edit/:id",
    //GET_INFO: url_usuario + "empresa/edit/:id",
    //UPDATE_CREDENTIAL: url_usuario + "empresa/credencial/:id",
    DELETE_COMPANY: url_usuario + "empresa/:id",
    GET_COMPANY: url_usuario + "empresa",
    GET_ONE:url_usuario+"empresa/:id",
    GET_LOGO: url_usuario + "empresa/logo",
  },
  ROL: {
    GET_ROLES: url_usuario + "rol/list",
    GET_ROL: url_usuario + "rol/:id",
  },
  VIAJE: {
    GET_ALL_PASSANGERS:url_venta + "viaje/all/pasajeros",
    GET_TRAVEL_BOARDING: url_venta + "viaje/punto-abordaje",
    GET_ABORDAJE: url_venta + "viaje/abordaje/:id",
    GET_TRAVEl_BUS: url_venta + "viaje/transporte/:id",
    GET_ALL_EVENT: url_venta + "viaje/evento/:viaje/:tramo",
    GET_STATUS: url_venta + "viaje/estado-viaje",
    GET_PASSANGER: url_venta + "viaje/pasajero/:id",
    GET_ONE: url_venta + "viaje/:id",
    GET_ONE_ALL_DETAIL: url_venta + "viaje/detalle/:id",
    UPDATE_ONE: url_venta + "viaje/:id",
    SEARCH: url_venta + "viaje/search/list",
    DELETE_ONE: url_venta + "viaje/:id",
    //api de traslado
    GET_SIMILARES: url_venta + "viaje/similares/",
    GET_OCUPADOS_TRAMO: url_venta + "viaje/ocupado/tramo/:id",
    GET_DETALLE: "",
    GET_DATA: "",
  },

  FLOTA: {
    DELETE_XXXX: "",
    UPDATE_XXXX: "",
    CREATE_RESOURCE: url_transporte + "buses/resource",
    READ_MEDIA: url_transporte + "buses/media/:id",
    GET_BUS: url_transporte + "buses/buses",
  },
  TIPO_CARACTERISTICA: {
    GET: url_transporte + "tipocaracteristicas/",
  },
  BUS_NIT: {
    GET: url_venta + "busnit",
    READ_NITS: url_venta + "busnit/lista/nit",
    READ_BUSES: url_venta + "busnit/registrados",
    GET_DATA: url_venta + "busnit/info/",
  },
  NIT: {
    SEARCH_NIT: url_venta + "nit/search/:nit",
    GET_ALL: url_venta + "nit",
    SET: url_venta + "nit",
    UPDATE: url_venta + "nit/:id",
    GET_ONE: url_venta + "nit/:id",
    GET_BRANCH: url_venta + "nit/sucursal/:id",
    GET_BRANCH_AND_BUS: url_venta + "nit/sucursal/bus/:id",
    SET_BRANCH: url_venta + "nit/sucursal",
    UPDATE_BRANCH: url_venta + "nit/sucursal/:id",
    GET_ONE_BRANCH: url_venta + "nit/sucursal/info/:id",
    GET_DOSIFICACION: url_venta + "nit/sucursal/dosificacion/:id",
    SET_DOSIFICACION: url_venta + "nit/sucursal/dosificacion/:id",
    GET_BUS: url_venta + "nit/bus",
  },
  BUS: {
    CREATE: url_transporte + "buses",
    GET_BUS_PISO: url_transporte + "buses/buses",
    GET: url_transporte + "buses/bus",
    GET_ONE_BUS: url_transporte + "buses/:id",
    GET_ALL_INFO: url_transporte + "buses/informacion/all",
    GET_CARACTERISTICA: url_transporte + "tipocaracteristicas",
    CREATE_PISO:url_transporte + "pisos/bus/:id",
    UPDATE_BUS: url_transporte + "buses/:id",
    DELETE_BUS: url_transporte + "buses/:id"
  },
  DETALLE_SUCURSAL: {
    GET: url_venta + "detalle-sucursal/",
    GET_NIT: url_venta + "detalle-sucursal/nit/:id",
    GET_NITS: url_venta + "detalle-sucursal/nit/",
  },
  TIPO_PERSONAL: {
    UPDATE_TYPE: url_usuario + "tipopersonal/edit/:id",
    GET_TYPE: url_usuario + "tipopersonal/edit/:id",
    DELETE_TYPE: url_usuario + "tipopersonal/:id",
  },
  PERSONAL_A_BORDO: {
    GET: `${url_venta}personalabordo/`,
    GET_BY_VIAJE: `${url_venta}personalabordo/list/travel/:id`,
  },
  ///////////////////ENCOMIENDA//////////////////////
  ////ENCOMIENDA
  //TIPO OBJETO
  TIPO_OBJETO_ENCOMIENDA: {
    GET_TIPO_OBJETOS: url_encomienda + "tipoobjeto",
    UPDATE_TIPO_OBJETO: url_encomienda + "tipoobjeto/edit/:id",
    GET_TIPO_OBJETO: url_encomienda + "tipoobjeto/edit/:id",
    DELETE_TIPO_OBJETO: url_encomienda + "tipoobjeto/:id",
  },
  //TIPO SOLICITUD
  TIPO_SOLICITUD_ENCOMIENDA: {
    GET_TIPO_SOLICITUDES: url_encomienda + "tiposolicitud",
    UPDATE_TIPO_SOLICITUD: url_encomienda + "tiposolicitud/edit/:id",
    GET_TIPO_SOLICITUD: url_encomienda + "tiposolicitud/edit/:id",
    DELETE_TIPO_SOLICITUD: url_encomienda + "tiposolicitud/:id",
  },
  //TIPO SERVICIO
  TIPO_SERVICIO_ENCOMIENDA: {
    GET_TIPO_SERVICIOS: url_encomienda + "tiposervicio",
    UPDATE_TIPO_SERVICIO: url_encomienda + "tiposervicio/edit/:id",
    GET_TIPO_SERVICIO: url_encomienda + "tiposervicio/edit/:id",
    DELETE_TIPO_SERVICIO: url_encomienda + "tiposervicio/:id",
  },
  //TIPO CUIDADO
  TIPO_CUIDADO_ENCOMIENDA: {
    GET_TIPO_CUIDADOS: url_encomienda + "tipocuidado",
    UPDATE_TIPO_CUIDADO: url_encomienda + "tipocuidado/edit/:id",
    GET_TIPO_CUIDADO: url_encomienda + "tipocuidado/edit/:id",
    DELETE_TIPO_CUIDADO: url_encomienda + "tipocuidado/:id",
  },
  //VIAJES
  VIAJE_ENCOMIENDA: {
    GET_VIAJES: url_encomienda + "viaje",
    UPDATE_VIAJE: url_encomienda + "viaje/edit/:id",
    GET_VIAJE: url_encomienda + "viaje/edit/:id",
    DELETE_VIAJE: url_encomienda + "viaje/:id",
    GET_ALL_TRAVEL: url_encomienda + "viaje/obtenerencomiendasyviajes",
  },
  MOVIMIENTO: {
    GET_ALL: url_encomienda + "movimiento",
    GET_MOVIMIENTO_PUBLIC: url_encomienda + "movimiento/public",
    GET_MOVIMIENTO_DETALLADO_ADMIN: url_encomienda + "movimiento/detalle",
    GET_MOVIMIENTO_ADICIONAL_ADMIN:
      url_encomienda + "movimiento/detalleAdicional",
    DELETE: `${url_encomienda}/movimiento/:id`,
  },
  CLIENTE: {
    GET_BY_CI: url_encomienda + "cliente/:id",
    UPDATE_WITH_UBI: `${url_encomienda}/cliente/withubication/:id`,
  },
  UBICACION_CLIENTE: {
    GET_ALL_BY_CLIENTE: url_encomienda + "ubicacion-cliente/:id",
  },
  //////////////////////////////////////////////////////////////////////77
  CARACTERISTICA: {
    GET: url_transporte + "tipocaracteristicas/",
  },
  UBICACION: {
    SAVE_UBICACION: url_venta + "ubicacion",
    GET_TIPO_UBICACION:url_venta + "tipoubicacion",
    LIST_NO_TREE:url_venta+"ubicacion/list/notree",
    UPDATE_ESTADO: url_transporte + "ubicacion/",
    GET_TERMINALES_EMPRESA: url_venta + "ubicacion/terminal/empresa",
    GET_UBICACIONES_SIN_PADRE: url_venta + "ubicacion/notree",
    GET_FOTO: `${url_venta}/ubicacion/files/:name`,
    GET_PUNTOS_ABORDAJE: url_venta + "ubicacion/ubicacion-terminal",
    SET_PUNTO_ABORDAJE: url_venta + "ubicacion/ubicacion-terminal",
    GET_ONE_PUNTO_ABORDAJE: url_venta + "ubicacion/ubicacion-terminal/:id",
    DELETE_PUNTO_ABORDAJE: url_venta + "ubicacion/ubicacion-terminal/:id",
  },
  TERMINAL: {
    CREATE: url_venta + "terminal/create",
    GET: url_venta + "terminal/:id",
    UPDATE: url_venta + "terminal/editar/:id",
    LISTAR: url_venta + "terminal/listar",
    GET_SUCURSALES: url_venta + "terminal/sucursal",
  },
  TRASLADO: {
    GET: url_venta + "traslado",
    GET_TRAVEL: url_venta + "traslado/:id",
    INIT_TRASLADO: url_venta + "traslado/init",
    VALIDATE: url_venta + "traslado/validate/:id",
    CANCEL_TRASLADO: url_venta + "traslado/cancel/:id",
  },
  TIPO_CUIDADO: {
    GET: url_encomienda + "tipocuidado",
  },
  UBICACION_VIAJE: {
    GET_LIST: url_venta + "ubicacion/ubicaciones",
    GET: url_venta + "ubicacion",
  },
  UBICACION_TERMINAL: {
    GET_PUNTOS_ABORDAJE: url_venta + "ubicacion-terminal/terminal",
  },
  SOLICITUD_ENCOMIENDA: {
    GET_BUSQUEDA:url_encomienda + "solicitud-encomienda/busqueda",
    CREATE: url_encomienda + "solicitud-encomienda",
    GET_DETALLE_ONE: url_encomienda + "solicitud-encomienda/detalle/:id",
    UPDATE_ONE: url_encomienda + "solicitud-encomienda/:id",
    GET_DETALLE_ALL_ONE: url_encomienda + "solicitud-encomienda/all/detalle/:id",
    //probar
    GET_BY_ID: url_encomienda + "solicitud-encomienda/:id",
    /*GET: url_encomienda + "solicitud-encomienda",
    GET_BY_ID: url_encomienda + "solicitud-encomienda/:id",
    VERIFY_PASSWORD: url_encomienda + "solicitud-encomienda/verify/",
    UPDATE_DESTINO: `${url_encomienda}/solicitud-encomienda/destino/:id`,*/
  },
  GUIA_SOLICITUD: {
    GET_GUIDE_WITH_TRAVEL: url_encomienda + "guia-encomienda/despacho/viaje",
    GET_BY_DESTINO: url_encomienda + "guia-encomienda/sucursal",
    DELETE_ONE: url_encomienda + "guia-encomienda/guia/:id/:motivo",
    LIST_BY_FILTER: url_encomienda + "guia-encomienda/list",
    SET_TRAVEL: url_encomienda + "guia-encomienda/viaje",
    GET_BY_GUIA: url_encomienda + "guia-encomienda/search",
    SET_ENTREGA: url_encomienda + "guia-encomienda/entrega",
    REMOVE_MOVIMIENTO: url_encomienda + "guia-encomienda/movimiento/:id",
    /*
    GET: url_encomienda + "guia-encomienda",
    GET_WITHOUT_TRAVEl: url_encomienda + "guia-encomienda/despacho",
    DELETE_TRAVEL_FROM_GUIDE: url_encomienda + "guia-encomienda/viaje/remove",
    SET_FACTURA: url_encomienda + "guia-encomienda/factura/:id",
    GET_FACTURA: url_encomienda + "guia-encomienda/factura/info/:id",
    SEARCH: url_encomienda + "guia-encomienda/search",*/
  },
  TRANSPORTE: {
    GET_TRANSPORTE_ENCOMIENDA: url_transporte + "buses/busencomienda",
  },
  RUTA: {
    GET_ROUTE: url_venta + "ruta",
    GET_ROUTE_TRAMO: url_venta + "ruta/:id",
    DELETE_ROUTE_TRAMO: url_venta + "ruta/:id",
    GET_ROUTE_INFO: url_venta + "ruta/info/:id",
    UPDATE_ROUTE_INFO: url_venta + "ruta/edit/:id",
    GET_FOTO: `${url_venta}ruta/files/:name`,
    GET_NIT_BY_ROUTE: url_venta + "ruta/nit/:ruta",
    CREATE_TRAMO: url_venta + "ruta/tramo/:id",
  },
  HORARIO: {
    GET_ALL: `${url_venta}horario/ruta/:id`,
    DELETE: `${url_venta}horario/ruta/:id`,
    CREATE: `${url_venta}horario/ruta/:id`,
    INFO: `${url_venta}horario/info/:id`,
  },
  PLANIFICACION: {
    GET: url_venta + "planificacion",
    GET_TRAVEL: url_venta + "planificacion/viaje",
    VERIFY:url_venta + "planificacion/verificar/:id"
  },
  PUNTO_ABORDAJE: {
    GET: url_venta + "ubicacion-terminal/",
    CREATE: url_venta + "ubicacion-terminal",
    DELETE: url_venta + "ubicacion-terminal/delete/",
  },
  DOSIFICACION: {
    GET: url_venta + "dosificacion/",
  },
  BOLETO: {
    GET: url_venta + "boleto",
    VALIDATE: url_venta + "boleto/validation",
    VENDIDOS: url_venta + "boleto/vendidos/",
    REPRINT: url_venta + "boleto/reimpresion/",
    //traslado
    GET_OCUPADOS_TRAMO: "",
  },
  VENTA: {
    GET_QR: url_venta + "venta/qr/:id",
    GET_QR_GENERATE: url_venta + "venta/generate/qr",
    GET: url_venta + "venta",
    DELETE: url_venta + "venta/:id/:motivo",
    GET_TRAVEL_SELL: url_venta + "venta/viaje/:id",
    GET_DETAIL_ALL: url_venta + "venta/informe/detalle/:viaje",
    GET_ONE_DETAIL: url_venta + "venta/detalle/:id",
    GET_ONE_DETAIL_SERVICE: url_venta + "venta/detalle/servicio/:id",
    GET_SELL_SERVICE: url_venta + "venta/servicio"
    //getAllVentaViaje: url_venta + 'viajes/consulta/vendidos',
    /*GET_TRAVEL_SELL: url_venta + "viajes/consulta/vendidos",
    GET_SELL_ALL: url_venta + "viajes/consulta/vendidos/general/:id",
    GET_INFO: url_venta + "venta/informe/",
    GET_LIST_ONLINE: url_venta + "venta/online/lista",
    GET_ALL_ONLINE: url_venta + "venta/online/all",
    GET_DETAIL_ALL: url_venta + "venta/informe/detalle/:viaje",*/
  },
  TRAMO: {
    GET_RUTA: url_venta + "tramo/ruta/:id",
  },
  DETALLE_ZONA: {
    GET: url_venta + "zona-detalle/",
  },
  RESERVA: {
    RESEND: url_venta + "reserva/enviar/:id",
    CONTINUE: url_venta + "reserva/notification",
    GET_ALL_ONLINE:url_venta + "reserva/online/list",
    GET_DETAIL:url_venta + "reserva/detalle/:id",
    GET_ALL: url_venta + "reserva",
    DELETE: url_venta + "reserva/:id",
    GET_BY_TRAVEL: url_venta + "reserva/viaje/:id",
    GET_BY_TRAPASO_TRAVEL: url_venta + "reserva/viaje/traspaso/:id",
    GET_ONE: url_venta + "reserva/:id",
    //traslados
    GET_RESERVADOS: "",
    GET_OCUPADOS_TRAMO: url_venta + "reserva/ocupado/tramo/:id",

    /*GET_OCUPADOS_TRAMO: url_venta + "reserva/ocupados/tramo/:id",
    GET: url_venta + "reserva/:id",
    GET_RESERVADOS: url_venta + "reserva/viaje/:id",
    GET_DETAIL: url_venta + "reserva/detalle/:id",
    CREATE: url_venta + "reserva/create",
    SEARCH: url_venta + "reserva/search/ad",
    RESEND: url_venta + "reserva/enviar/:id",
    GET_DETAIL_ONLINE: url_venta + "reserva/info/online/:id",
    CONTINUE: url_venta + "reserva/notification",
    GET_PASAJEROS: url_venta + "reserva/pasajeros/:id",
    SET_VENCIMIENTO: url_venta + "reserva/vencimiento/:id",
    GET_ASIENTO_STATUS: url_venta + "reserva/asientos/:id",*/
  },
  REPORTE: {
    GET_LIST_PASSANGER: url_venta + "reporte/viaje/list/:id",
    GET_MANIFIESTO_BY_VIAJE: url_venta + "reporte/encomienda/manifiesto/:viaje",
    GET_VENTA_BY_VIAJE: url_venta + "reporte/by/viaje",
    GET_DIA_VENTA_BY_VIAJE: url_venta + "reporte/by/dia/venta",
    GET_ALL_VENTA_BY_VIAJE: url_venta + "reporte/by/detalle/viaje/:id",
    GET_BY_PERFIL: url_venta + "reporte/by/perfil",
    DETAIL_BY_DAY: url_venta + "reporte/detalle/dia",
    /* GET_GENERAL: url_venta + "reporte/",
    ENCOMIENDAS_POR_VIAJE: url_encomienda + "reporte/encomiendas/viaje/",
    GET_GENERAL_ENCOMIENDA: url_encomienda + "reporte/encomiendas/reporte",
    GET_VENTA_ONLINE: url_venta + "reporte/online",
    GET_GASTOS_POR_TRAMO: url_venta + "dvc/cuentas/",
    GET_TOTAL_VENTAS_POR_PUNTO_ABORDAJE:
      url_venta + "dvc/cuentas/total/punto-abordaje/",
    GET_GANANCIAS_BUS_RUTA: url_venta + "reporte/gananciasxbusxruta/", */
  },
  PASAJERO: {
    GET_BY_DNI: url_venta + "cliente/cliente/:dni",
    SEARCH: url_venta + "cliente/search/:id",
    UPDATE_ONE: url_venta + "cliente/:id",
  },
  FACTURA: {
    GET_CODE: url_venta + "factura/certificacion",
    GET_SUCURSAL: url_venta + "factura/sucursal/:id",
    VERIFY_ENCOMIENDA: url_venta + "factura/encomienda/verify/:ruta",
    VERIFY_VIAJE: url_venta + "factura/viaje/verify/:id",
    VALIDATE_VIAJE: url_venta + "factura/encomienda/validate/:id", //verificar si se utiliza
    ACTIVAR_CONTINGENCIA:url_venta+"factura/activar/contingencia/:nitId"
    /*CANCEL_FACTURA: url_venta + "factura/cancel/:id",
    GET_ENCOMIENDA: url_venta + "factura/encomienda/impresion/:id",
    GET_FACTURA_ENCOMIENDA: url_venta + "factura/encomienda/info/:id",
    GENERATE_ENCOMIENDA: url_venta + "factura/encomienda/generate",
    */
  },
  MANIFIESTO: {
    MANIFIESTO_DE_CARGA: url_encomienda + "guia-encomienda/info/carga/:viaje",
  },
  COMISION: {
    GET_LIST: url_venta + "comision/lista",
    CREATE: url_venta + "comision",
  },
  PLAN_CUENTA: {
    GET_LIST: url_venta + "plancuenta",
  },
  CUENTA_SUCURSAL: {
    GET_BY_ROUTE: url_venta + "dsc/:ruta/:viaje",
  },
  CUENTA_VIAJE: {
    GET_LIST: url_venta + "dvc",
  },
};
